import React from 'react';
import logo from 'assets/images/Marketplace/logo-contact.svg';
import QuestionForm from 'shared/QuestionForm';

export default function HomeContactSection() {
  return (
    <div className="contact-section">
      <div className="contact-text">you have </div>

      <div
        className="form-wrapper"
        style={{
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div className="form-logo">
          <img src={logo} alt="" />
        </div>

        <div className="form-text">
          We’ll be happy to provide you with all of the answers you need! Please
          fill out this form, and we’ll contact you as soon as possible
        </div>

        <div className="form-box">
          <QuestionForm />
        </div>
      </div>

      <div className="light-text contact-text">Questions?</div>
    </div>
  );
}
